module.exports = __webpack_public_path__ + "static/media/grph-stat-anxiety-dec.aa026b9a.svg";